import api from '~/api';

export default ({ app }, inject) => {
  // 将 API 模块注入到 Vue 实例和上下文中
  inject('api', api);
};